import { AccordionItemV2, AccordionV2, Breadcrumb, Button, Dropdown, Icon, Modal, Search, TextArea, TextInput } from "pepsico-ds";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from 'react-toastify';
import "./pam_safe_create_update.css";
import { useEffect, useState, useRef, useCallback } from "react";
import { useLoading } from "../../loader";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const PamSafeCreateUpdate = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { REACT_APP_API_ENDPOINT } = process.env;
    const { showLoader, hideLoader } = useLoading();
    const [requestType, setRequestType] = useState([{ id: '1', displayText: t("mypam.create_safe"), value: 'Create_Safe' }]);
    const selectedRequestTypeRef = useRef([{ id: '1', displayText: t("mypam.create_safe"), value: 'Create_Safe' }]);
    const [shortName, setShortName] = useState("");
    const [environment, setEnvironment] = useState([]);
    const selectedEnvironmentRef = useRef([]);
    const environments = [
        {
            id: 'PR', displayText: t("mypam.production")
        },
        {
            id: 'DV', displayText: t("mypam.development")
        },
        {
            id: 'IT', displayText: t("mypam.integrated_test")
        },
        {
            id: 'QA', displayText: t("mypam.quality_assurance")
        },
        {
            id: 'PP', displayText: t("mypam.pre_production")
        }
    ];
    const [description, setDescription] = useState("");
    const [updateSafeName, setUpdateSafeName] = useState(null);
    const [applications, setApplications] = useState([]);
    const [disableAppSearch, setDisableAppSearch] = useState(false);
    const [selectedApp, setSelectedApp] = useState('')
    const [prefixValue, setPrefixValue] = useState("AP");
    const [isMobile, setIsMobile] = useState(false);
    const [loader, setLoader] = useState(false);
    const [users, setUsers] = useState([]);
    const [disableGpidSearch, setDisableGpidSearch] = useState(false);
    const [disableGpidSearchMember, setDisableGpidSearchMember] = useState(false);
    const [queryGPID, setQueryGPID] = useState('');
    const [queryGPIDMember, setQueryGPIDMember] = useState('');
    const [queryGPIDMemberUpdate, setQueryGPIDMemberUpdate] = useState('');
    const [safes, setSafes] = useState([]);
    const [safeMembers, setSafeMembers] = useState([]);
    const [safeOwners, setSafeOwners] = useState([]);
    const [existingSafeMembers, setExistingSafeMembers] = useState([]);
    const [existingSafeMembersResp, setExistingSafeMembersResp] = useState([]);
    const [safeOwnersOnUpdate, setSafeOwnersOnUpdate] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [copyButtonText, setCopyButtonText] = useState(t('nonArExtension.copy'));
    const [requestData, setRequestData] = useState(null);
    const [searchedAppQuery, setSearchedAppQuery] = useState("");

    useEffect(() => {
        // Create a MutationObserver to watch for attribute changes
        const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === "attributes" && mutation.attributeName === "data-lang") {
                const requestTypeOptions = [
                    { id: '1', displayText: t("mypam.create_safe"), value: 'Create_Safe' },
                    { id: '2', displayText: t("mypam.update_safe"), value: 'Update_Safe' }
                ];
                const prevSelectedRequestType = {...selectedRequestTypeRef.current[0]};
                setRequestType(requestTypeOptions?.filter?.((o)=>o.id === prevSelectedRequestType.id));

                const environments = [
                    {
                        id: 'PR', displayText: t("mypam.production")
                    },
                    {
                        id: 'DV', displayText: t("mypam.development")
                    },
                    {
                        id: 'IT', displayText: t("mypam.integrated_test")
                    },
                    {
                        id: 'QA', displayText: t("mypam.quality_assurance")
                    },
                    {
                        id: 'PP', displayText: t("mypam.pre_production")
                    }
                ];
                const prevSelectedEnvironments = {...selectedEnvironmentRef.current?.[0]};
                if(prevSelectedEnvironments?.id) setEnvironment(environments?.filter?.((o)=>o.id === prevSelectedEnvironments.id));
            }
        });
        });

        // Start observing the body element
        observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["data-lang"],
        });

        // Cleanup observer on unmount
        return () => {
        observer.disconnect();
        };
    }, []);

    function useDebouncedCallback(callback, delay = 1000) {
        const timerRef = useRef();

        const debounced = useCallback((...args) => {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(() => {
                callback(...args);
            }, delay);
        }, [callback, delay]);

        useEffect(() => {
            return () => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                }
            };
        }, []);

        return debounced;
    }

    const debouncedSearchGPID = useDebouncedCallback((q, isMember = false) => {
        if (q?.trim().length >= 3) {
            gpidSerach(q, isMember);
        } else {
            setUsers([]);
        }
    }, 2000);

    const gpidSerach = (val, isMemberSearch = false) => {
        const isNumeric = (value) => value !== "" && !isNaN(value) && !isNaN(Number(value));
        if (!val || val?.length < 3) {
            return
        }
        showLoader();
        if (!isMemberSearch) setDisableGpidSearch(true);
        if (isMemberSearch) setDisableGpidSearchMember(true);
        setLoader(true);
        axios.post(REACT_APP_API_ENDPOINT + "user/searchuser", {
            [isNumeric(val) ? "gpid" : "email"]: val,
            "fetchOnlyActiveUsers": true
        }).then((response) => {
            hideLoader();
            if (!isMemberSearch) setDisableGpidSearch(false);
            if (isMemberSearch) setDisableGpidSearchMember(false);
            setLoader(false);

            if (response?.data?.status === "Failed") {
                toast.error(response?.data?.errorMessage || t("mypam.an_error_occurred"));
                setUsers([]);
                return;
            }

            if (!response?.data?.userData) {
                toast.error(t("mypam.no_users_match_your_search_criteria"))
                return;
            }
            const mapped = Object.values(response?.data?.userData).map(item => ({
                id: item.uid,
                label: `${item.uid} - ${item.givenName} ${item.sn} - ${item.mail}`
            }));

            setUsers(mapped);
        }).catch((error) => {
            hideLoader();
            if (!isMemberSearch) setDisableGpidSearch(false);
            if (isMemberSearch) setDisableGpidSearchMember(false);
            setLoader(false);
            setUsers([]);
            toast.error(error?.response?.data?.errorMessage || error?.message || t("mypam.an_error_occurred"));
            console.log('error', error);
        })
    }

    const getUserSvcDetails = () => {
        showLoader();
        setLoader(true);
        axios
            .get(REACT_APP_API_ENDPOINT + "pam/fetchSafeDetails", {
            })
            .then((response) => {

                if (response?.data?.status == "Failed") {
                    toast.error(response?.data?.errorMessage);
                    hideLoader();
                    setLoader(false);
                }
                else {
                    let usersvcdata = response?.data;
                    let res = usersvcdata;
                    if(!res?.safes?.length)toast.error(t("mypam.no_safe_accounts"));
                    const svcSafes = res?.safes?.map((acc, i) => ({
                        id: acc,
                        displayText: acc || `Unnamed #${i}`
                    }));
                    setSafes([...svcSafes]);
                    hideLoader();
                    setLoader(false);
                }

            })
            .catch((error) => {
                hideLoader();
                setLoader(false);
                console.error("Error fetching data:", error);
                return '';
            });
    };

    useEffect(() => {
        if(requestType?.[0]?.value === "Update_Safe" && !safes?.length){
            getUserSvcDetails();
        }
    }, [requestType]);

    const addToSafeMembers = (val, isUpdate = false) => {
        if (!val?.id) return;

        const parts = String(val.id).split('-');
        const selectedGpid = parts[parts.length - 1];

        if (!selectedGpid) return;

        const memberToAdd = { ...val, id: selectedGpid };

        if (isUpdate) {
            setExistingSafeMembers((prev) =>
                prev.some((item) => item.id === selectedGpid)
                    ? prev
                    : [...prev, memberToAdd]
            );
        } else {
            setSafeMembers((prev) =>
                prev.some((item) => item.id === selectedGpid)
                    ? prev
                    : [...prev, memberToAdd]
            );
        }

    };

    const addToSafeOwner = (val) => {
        if (!val?.id) return;

        const parts = String(val.id).split('-');
        const selectedGpid = parts[parts.length - 1];

        if (!selectedGpid) return;

        const memberToAdd = { ...val, id: selectedGpid };

        setSafeOwners((prev) =>
            prev.some((item) => item.id === selectedGpid)
                ? prev
                : [...prev, memberToAdd]
        );
    };

    const removeFromSafeMembers = (gpidToRemove, isUpdate = false) => {
        if (isUpdate) {
            setExistingSafeMembers(prev => prev.filter(item => item?.id !== gpidToRemove));
        } else {
            setSafeMembers(prev => prev.filter(item => item?.id !== gpidToRemove));
        }
    }

    const getExistingSafeMembers = (val) => {
        showLoader();
        setLoader(true);

        const payload = {
            safeCn: val[0]?.id
        }
        axios.post(REACT_APP_API_ENDPOINT + "pam/fetchSafeMembers", payload)
            .then((response) => {

                if (response?.data?.status == "Failed") {
                    toast.error(response?.data?.errorMessage);
                    hideLoader();
                    setLoader(false);
                }
                else {
                    let usersvcdata = response?.data;
                    let res = usersvcdata?.members;
                    let owners = usersvcdata?.owners;
                    const mapped = res.map(item => ({
                        id: item,
                        label: item
                    }));
                    const mappedOwners = owners.map(item => ({
                        id: item,
                        label: item
                    }));
                    setSafeOwnersOnUpdate(mappedOwners);
                    setExistingSafeMembers(mapped);
                    setExistingSafeMembersResp(mapped);
                    hideLoader();
                    setLoader(false);
                }

            })
            .catch((error) => {
                hideLoader();
                setLoader(false);
                console.error("Error fetching data:", error);
                return '';
            });

    }

    const clearUsers = (isMember = false) => {
        setUsers([]);
        if (isMember) setQueryGPIDMember('');
        else setQueryGPID('');
    }

    const clearUsersUpdate = () => {
        setQueryGPIDMemberUpdate('')
    }

    const searchApplications = async (text) => {
        if (!text || text?.trimStart()?.length < 3) {
            setApplications([]);
            return;
        }
        try {
            showLoader();
            setDisableAppSearch(true);
            setLoader(true);
            const response = await axios.post(
                `${REACT_APP_API_ENDPOINT}pam/getApplicationList`,
                { appFilter: text?.trimStart() }
            );
            if (response?.data?.appList?.length == 0) {
                toast.error(t("mypam.no_applications_match_your_search_criteria"))
            }
            const list = response?.data?.appList ?? {};
            const mapped = Object.values(list).map((item) => ({
                id: item,
                label: item,
            }));
            setApplications(mapped);
            hideLoader();
            setDisableAppSearch(false);
            setLoader(false);
        } catch (error) {
            toast.error(error.message)
            console.log('error', error);
            hideLoader();
            setDisableAppSearch(false);
            setLoader(false);
        } finally {
            hideLoader();
            setDisableAppSearch(false);
            setLoader(false);
        }
    };

    const debouncedSearch = useDebouncedCallback((q) => {
        if (q?.trimStart()?.length >= 3) {
            searchApplications(q);
        } else {
            setApplications([]);
        }
    }, 500);

    const requestTypeOptions = [
        { id: '1', displayText: t("mypam.create_safe"), value: 'Create_Safe' },
        { id: '2', displayText: t("mypam.update_safe"), value: 'Update_Safe' }
    ];

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const resetCreateSafeFields = () => {
        setSelectedApp('');
        setEnvironment([]);
        selectedEnvironmentRef.current=[];
        setShortName('');
        setDescription('');
        setSafeOwners([]);
        setSafeMembers([]);
        setApplications([]);
        const accordionItems = document.querySelectorAll('.accordion-item-v1');
        if (accordionItems[0]) {
            accordionItems[0].setAttribute('aria-expanded', 'true');
        }
        if (accordionItems[1]) {
            accordionItems[1].setAttribute('aria-expanded', 'false');
        }

        const clearButton = document.querySelector('.create-safe-app-name .search-clearable-icon button');
        if (clearButton) {
            clearButton.click();
            document.activeElement.blur();
        }
    }


    const handleCreateSafe = () => {
        showLoader();
        setLoader(true);
        const payload = {
            applicationName: selectedApp?.label,
            environment: environment?.[0]?.displayText,
            shortName: shortName,
            description: description,
            safeName: (`${prefixValue}_${environment?.[0]?.id}_${shortName}`).toUpperCase(),
            safeOwnerGpid: safeOwners?.[0]?.id,
            addMembers: safeMembers?.map?.((rec) => rec?.id)
        };
        axios.post(REACT_APP_API_ENDPOINT + "pam/safeManagement/createSafe", payload)
            .then((response) => {
                if (!response?.data?.success) {
                    toast.error(response?.data?.errorMessage || response?.data?.message, "error");
                    hideLoader();
                    setLoader(false);
                }
                else {
                    setShowModal(true);
                    setRequestData(response?.data);
                    toast.success(response?.data?.message, "success");
                    hideLoader();
                    setLoader(false);
                    resetCreateSafeFields();
                }
            })
            .catch((error) => {
                hideLoader();
                setLoader(false);
                console.error("Error fetching data:", error);
            });
    }

    const resetUpdateSafeFields = () => {
        setUpdateSafeName(null);
        setExistingSafeMembers([]);
        const dropdownButton = document.querySelector('.safe-name-dropdown .icon-container > div:first-child button');
        if (dropdownButton) {
            dropdownButton.click();
            document.activeElement.blur();
        }
    }

    const handleUpdateSafe = () => {
        showLoader();
        setLoader(true);

        const addMembersArr = existingSafeMembers.filter(obj2 =>
            !existingSafeMembersResp.some(obj1 => obj1.id === obj2.id)
        );

        const removeMembersArr = existingSafeMembersResp.filter(obj2 =>
            !existingSafeMembers.some(obj1 => obj1.id === obj2.id)
        );

        const payload = {
            safeName: updateSafeName?.[0]?.displayText,
            applicationName: "",
            addMembers: addMembersArr?.map?.((rec) => rec?.id),
            removeMembers: removeMembersArr?.map?.((rec) => rec?.id)
        };
        axios.post(REACT_APP_API_ENDPOINT + "pam/safeManagement/updateSafe", payload)
            .then((response) => {
                if (!response?.data?.success) {
                    toast.error(response?.data?.errorMessage || response?.data?.message, "error");
                    hideLoader();
                    setLoader(false);
                }
                else {
                    setShowModal(true);
                    setRequestData(response?.data);
                    toast.success(response?.data?.message, "success");
                    hideLoader();
                    setLoader(false);
                    resetUpdateSafeFields();
                }
            })
            .catch((error) => {
                hideLoader();
                setLoader(false);
                console.error("Error fetching data:", error);
            });
    }

    function areArraysSame(a1, a2) {
        if (a1.length !== a2.length) return false;
        const ids1 = new Set(a1.map(obj => obj.id));
        const ids2 = new Set(a2.map(obj => obj.id));
        if (ids1.size !== ids2.size) return false;
        for (let id of ids1) {
            if (!ids2.has(id)) return false;
        }
        return true;
    }

    const closeModal = () => {
        setShowModal(false);
    }

    const onClickCopynumber = () => {
        if (requestData?.requestNumber) {
            navigator.clipboard.writeText(requestData?.requestNumber?.toString?.()).then(() => {
                setCopyButtonText(t('nonArExtension.copied'));
            }).catch(err => {
                console.error("Failed to copy text: ", err);
            });
        }
    };

    const onViewRequest = () => {
        const statePayload = { type: "requestNumber", value: requestData?.requestNumber};
        navigate("/audit-requests", { state: statePayload });
    }

    const renderConfirmModal = () => {
        return (
            <div className="confirm-modal">
                <Modal
                    showModal={showModal}
                    className="entra-request-success-modal"
                    onCloseModal={closeModal}
                    closeOnOutsideClick = {false}
                    notificationsProps={{
                        secondaryActionLabel: (
                            <>
                                <Icon
                                    alt="alt value"
                                    icon={copyButtonText == t('nonArExtension.copied') ? "check" : "content_copy"}
                                    size="medium"
                                    style={{ marginRight: '6px', display: 'unset' }}
                                />

                                {copyButtonText}
                            </>
                        ),
                        secondaryActionOnClick: onClickCopynumber,
                        text: `${requestData?.requestNumber}`,
                        title: t('nonArExtension.request_number_title'),
                        type: 'info'
                    }}
                    showAuxiliaryButton={false}
                    showLink={false}
                    showPrimaryButton={true}
                    primaryButtonProps={{
                        onClick: onViewRequest,
                        size: 'medium',
                        text: t('homePage.view_request'),
                        variant: 'primary'
                    }}
                    showSecondaryButton={false}
                    showSlot
                    showTertiaryButton={true}
                    tertiaryButtonProps={{
                        onClick: closeModal,
                        size: 'medium',
                        text: t('nonArExtension.back'),
                        variant: 'tertiary'
                    }}
                    showCloseButton={true}
                    style={{}}
                    text={<>
                        <div style={{ marginTop: '10px'}}>
                        <p  className="modal-para-text">{t('mypam.mypam_request_confirmation_text')} 
                        </p>
                        </div>
                    </>}
                    title={t('entraGuest.entra_request_confirmation_title')}
                    type="fluid"
                    viewPort={`${isMobile ? "mobile" : "desktop"}`}
                >
                    <p style={{fontSize:'16px'}} className="modal-para-text">{`${t('entraGuest.see_all_your_requests_in_the')} `} <span className="view-request-txt">{`${t('entraGuest.view_request')} `}</span> {t('entraGuest.section_below')} 
                    </p>
                </Modal>
            </div>
        )
    }

    return <div className="create-update-safe-container h-100">
        <div className="create-update-safe-main-container ml-3">
           <div className="my-pam-safe-mgmt">
            <Breadcrumb
                homeIcon={{
                    icon: "home",
                    onClick:()=>{
                    navigate("/home")
                    }
                }}
                breadcrumbs={[
                    {
                        label: t("menu.home"),
                    },
                    {
                        label: <div onClick={()=>{
                            navigate("/pam-safe-create-update")
                        }}>{t("mypam.myPAM_safe_management")}</div>
                    },
                ]}
                className=""
                onClick={function Xs() { }}
                useAnchor
                style={{ marginBottom: "1rem !important", width: "96%" }}
            />
            </div>
            <div className="header_ar-title pb-0">
                <h1>{requestType?.[0]?.value === "Create_Safe" ? t("mypam.create_new_safe") : t("mypam.update_safe")}</h1>
            </div>
            {
                requestType?.[0]?.value === "Create_Safe" ?
                    <>
                        <AccordionV2
                            accordionTitle="Accordion Title"
                            className="accordion-container"
                            onClickAdd={function w8e() { }}
                            onUpdate={function w8e() { }}
                            presentation="box-shadow"
                            selectedItemIndex={0}
                            style={{}}
                        >
                            <AccordionItemV2
                                label={t("mypam.safe_details")}
                                onUpdate={function w8e() { }}
                                presentation="box-shadow"
                                icon="verified_user"
                            >
                                <div className="row">
                                    <div className="col-sm-6">
                                        <Dropdown
                                            childList={requestTypeOptions}
                                            label={t("mypam.request_type")}
                                            placeholder={t("RequestGPIDForNonEmployee.select_btn_label")}
                                            isClearable={false}
                                            selection="single"
                                            size="medium"
                                            setSelectedValue={(selected) => {
                                                setRequestType(selected);
                                                selectedRequestTypeRef.current = selected;
                                            }}
                                            selectedValue={requestType}
                                            onKeyDown={(e) => e.preventDefault()}
                                            showLabelIcon={false}
                                            isRequired
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="form-field">
                                            <div className="" style={{ display: 'flex', justifyContent: "space-between" }}>
                                                <label className="safe-name" style={{ display: "flex", alignItems: "center" }}>
                                                    {t("mypam.application_name")}
                                                </label>
                                                <label className="required-text $font-xsmall-regular" style={{ color: "var(--color-text-secondary)" }}>*Required</label>
                                            </div>
                                            <Search
                                                className="create-safe-app-name"
                                                isAutoComplete
                                                isClearable={true}
                                                required
                                                isRequired
                                                maxLength={20}
                                                isDisabled={disableAppSearch}
                                                onClear={() => {
                                                    setSelectedApp(null);
                                                }}
                                                onSelectOption={(val) => {
                                                    const sel = Array.isArray(val) ? val[0] : val;
                                                    setSelectedApp(sel);
                                                }}
                                                onSearch={(val) => searchApplications(val)}
                                                onUpdate={(text) => {
                                                    debouncedSearch(text);
                                                    setSearchedAppQuery(text.trimStart())
                                                }}
                                                placeholderText={t("mypam.search_for_an_application_placeholder")}
                                                size="medium"
                                                autoComplete="off"
                                                suggestions={applications}
                                                selectedValue={selectedApp}
                                                limitSuggestions={applications.length}
                                                searchTerm={searchedAppQuery}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <TextInput
                                            label={t("mypam.short_name")}
                                            value={shortName}
                                            onKeyDown={(e) => {
                                                const allowed = /^[A-Za-z0-9_]$/;
                                                const k = e.key;
                                                if (e.ctrlKey || e.metaKey ||
                                                    ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Home", "End", "Tab"].includes(k)
                                                ) {
                                                    return;
                                                }
                                                if (k.length === 1 && !allowed.test(k)) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onChange={(e) => setShortName(e.target.value)}
                                            className="input-margin-top-bottom-0"
                                            required
                                            placeholder={t("mypam.enter_short_name")}
                                            maxLength={5}
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <TextInput
                                            type="text"
                                            className="input-margin-top-bottom-0"
                                            label={t("mypam.safe_name")}
                                            value={(
                                                `${prefixValue ?? ""}_${environment?.[0]?.id ?? "<environment>"}_${shortName || "<App Name>"}`
                                            ).toUpperCase()}
                                            disabled
                                            maxLength={19}
                                            isClearable={false}
                                            required
                                            onPaste={(e) => e.preventDefault()}
                                            style={{ width: "100%" }}
                                        />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-6">
                                        <Dropdown
                                            childList={environments}
                                            label={t("mypam.environment")}
                                            placeholder={t("RequestGPIDForNonEmployee.select_btn_label")}
                                            menuPosition="bottom-right"
                                            isClearable={true}
                                            selection="single"
                                            size="medium"
                                            setSelectedValue={(selected) => {
                                                setEnvironment(selected);
                                                selectedEnvironmentRef.current = selected;
                                            }}
                                            selectedValue={environment}
                                            onKeyDown={(e) => e.preventDefault()}
                                            showLabelIcon={false}
                                            isRequired
                                        />
                                    </div>
                                    <div className="col-sm-6">
                                        <TextArea
                                            title={t("mypam.description")}
                                            label={t("mypam.description")}
                                            placeholder={t("mypam.describe_the_purpose_of_this_safe")}
                                            rows={4}
                                            style={{ width: "100%", maxWidth: "revert" }}
                                            required={true}
                                            onChange={(e) => setDescription(e.target.value)}
                                            value={description}
                                            showToolbar={false}
                                            showCharacterCount={false}
                                            maxLength={100}
                                            showLabelIcon={false}
                                        />
                                    </div>
                                </div>
                            </AccordionItemV2>
                            <AccordionItemV2
                                label={t("mypam.ownership_membership")}
                                onUpdate={function w8e() { }}
                                presentation="box-shadow"
                                icon="groups"
                                disabled={!selectedApp || !environment?.length || !shortName || !description}
                            >
                                <div className={isMobile ? "form-field w-100" : "form-field w-50 mx-auto"} >
                                    <div className="mb-2" style={{ display: 'flex', justifyContent: "space-between" }}>
                                        <label className="safe-name" style={{ display: "flex", alignItems: "center" }}>
                                            {t("mypam.safe_owner")}
                                        </label>
                                        <label className="required-text $font-xsmall-regular" style={{ color: "var(--color-text-secondary)" }}>*Required</label>
                                    </div>
                                    <Search
                                        isAutoComplete
                                        isClearable={queryGPID?.length > 0}
                                        onClear={() => { clearUsers(); setQueryGPID(""); }}
                                        maxLength={30}
                                        value={queryGPID}
                                        isDisabled={disableGpidSearch || safeOwners.length > 0}
                                        onSelectOption={(val) => {
                                            addToSafeOwner(val);
                                            setQueryGPID("");
                                            setUsers([]);
                                        }}
                                        onSearch={(event) => gpidSerach(event)}
                                        onUpdate={(text) => {
                                            setQueryGPID(text);
                                            debouncedSearchGPID(text);
                                        }}
                                        placeholderText={t("mypam.search_by_gpid_or_email")}
                                        size="medium"
                                        style={{}}
                                        autoComplete="off"
                                        suggestions={users}
                                        delay={0}
                                        limitSuggestions={users.length}
                                    />
                                    {safeOwners.length > 0 && <div>
                                        <label className="safe-name">{t("mypam.safe_owner")}</label>
                                        <div className="accountsAlign">
                                            {safeOwners?.map((acc, index) => (
                                                <span key={acc?.id} className="endPointInfo mr-1">{acc?.id}{" "}
                                                    <Icon
                                                        alt="alt value"
                                                        className="icon $color-icon small material-icons-outlined ml-1"
                                                        icon="close"
                                                        size="small"
                                                        onClick={() => setSafeOwners([])}
                                                        style={{ color: 'white', cursor: "pointer" }}
                                                    />
                                                </span>
                                            ))}
                                        </div>
                                    </div>
                                    }
                                </div>
                                <div className={isMobile ? "form-field w-100" : "form-field w-50 mx-auto"} style={{minHeight: "290px"}}>
                                    <div className="mb-2" style={{ display: 'flex', justifyContent: "space-between" }}>
                                        <label className="safe-name" style={{ display: "flex", alignItems: "center" }}>
                                            {t("mypam.add_members")}
                                        </label>
                                        <label className="required-text $font-xsmall-regular" style={{ color: "var(--color-text-secondary)" }}>*Required</label>
                                    </div>
                                    <Search
                                        isAutoComplete
                                        isClearable={queryGPIDMember?.length > 0}
                                        onClear={() => { clearUsers(true); setQueryGPIDMember(""); }}
                                        maxLength={30}
                                        value={queryGPIDMember}
                                        isDisabled={disableGpidSearchMember}
                                        onSelectOption={(val) => {
                                            addToSafeMembers(val);
                                            setQueryGPIDMember("");
                                            setUsers([]);
                                        }}
                                        onSearch={(event) => gpidSerach(event)}
                                        onUpdate={(text) => {
                                            setQueryGPIDMember(text);
                                            debouncedSearchGPID(text, true);
                                        }}
                                        placeholderText={t("mypam.search_by_gpid_or_email")}
                                        size="medium"
                                        style={{}}
                                        autoComplete="off"
                                        suggestions={users}
                                        delay={0}
                                        limitSuggestions={users.length}
                                    />
                                    {safeMembers.length > 0 && <div className="mb-1">
                                        <label className="safe-name">{t("mypam.added_members")}</label>
                                        <div className="accountsAlign">
                                            {safeMembers?.map((acc, index) => (
                                                <span key={acc?.id} className="endPointInfo mr-1">{acc?.id}{" "}
                                                    {!safeOwners?.some(owner => owner.id === acc?.id) &&
                                                        <Icon
                                                            alt="alt value"
                                                            className="icon $color-icon small material-icons-outlined ml-1"
                                                            icon="close"
                                                            size="small"
                                                            onClick={() => removeFromSafeMembers(acc?.id)}
                                                            style={{ color: 'white', cursor: "pointer" }}
                                                        />
                                                    }
                                                    {" "}</span>
                                            ))}
                                        </div>
                                    </div>
                                    }
                                </div>
                            </AccordionItemV2>
                        </AccordionV2>
                    </>
                    :
                    <>
                        <div className="udate-safe-container">
                            <div className="row mx-0">
                                <div class="accordion-item-container">
                                    <span class="icon $color-icon large material-icons-outlined $color-icon-default" role="img" aria-label="verified_user" style={{ fontSize: "24px" }}>
                                        verified_user
                                    </span>
                                    <div class="accordion-item-label-container">
                                        <div class="content-group-title">
                                            <span class="title $font-body-medium">
                                                {t("mypam.safe_details")}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3 mx-0">
                                <div className="col-sm-6">
                                    <Dropdown
                                        childList={requestTypeOptions}
                                        label={t("mypam.request_type")}
                                        placeholder={t("RequestGPIDForNonEmployee.select_btn_label")}
                                        isClearable={false}
                                        selection="single"
                                        size="medium"
                                        setSelectedValue={(selected) => {
                                            setRequestType(selected);
                                            selectedRequestTypeRef.current = selected;
                                        }}
                                        selectedValue={requestType}
                                        onKeyDown={(e) => e.preventDefault()}
                                        showLabelIcon={false}
                                        isRequired
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <Dropdown
                                        childList={safes}
                                        label={t('mypam.safe_name')}
                                        selection="single"
                                        isClearable
                                        isRequired
                                        menuPosition="bottom-right"
                                        showLabelIcon={false}
                                        size="medium"
                                        selectedValue={updateSafeName}
                                        setSelectedValue={(val) => {
                                            setUpdateSafeName(val);
                                            setSafeMembers([]);
                                            setSafeOwners([]);
                                            if (val) {
                                                getExistingSafeMembers(val);
                                            } else {
                                                setExistingSafeMembers([]);
                                            }
                                        }}
                                        className="safe-name-dropdown"
                                        placeholder={t("mypam.select_safe_name")}
                                        onKeyDown={(e) => e.preventDefault()}
                                    />
                                </div>
                            </div>
                            <hr />
                            <div className="row mx-0">
                                <div class="accordion-item-container">
                                    <span class="icon $color-icon large material-icons-outlined $color-icon-default" role="img" aria-label="verified_user" style={{ fontSize: "24px" }}>
                                        groups
                                    </span>
                                    <div class="accordion-item-label-container">
                                        <div class="content-group-title">
                                            <span class="title $font-body-medium">
                                                {t("mypam.ownership_membership")}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={isMobile ? "form-field w-100" : "form-field w-50 mx-auto"} >
                                <div className="mb-2" style={{ display: 'flex', justifyContent: "space-between" }}>
                                    <label className="safe-name" style={{ display: "flex", alignItems: "center" }}>
                                        {t("mypam.add_members")}
                                    </label>
                                    <label className="required-text $font-xsmall-regular" style={{ color: "var(--color-text-secondary)" }}>*Required</label>
                                </div>
                                <Search
                                    isAutoComplete
                                    isClearable={queryGPIDMemberUpdate?.length > 0}
                                    onClear={() => { clearUsersUpdate(); setQueryGPIDMemberUpdate(""); }}
                                    maxLength={30}
                                    value={queryGPIDMemberUpdate}
                                    isDisabled={disableGpidSearchMember || !updateSafeName?.length}
                                    onSelectOption={(val) => {
                                        addToSafeMembers(val, true);
                                        setQueryGPIDMemberUpdate("");
                                        setUsers([]);
                                    }}
                                    onSearch={(event) => gpidSerach(event)}
                                    onUpdate={(text) => {
                                        setQueryGPIDMemberUpdate(text);
                                        debouncedSearchGPID(text, true);
                                    }}
                                    placeholderText={t("mypam.search_by_gpid_or_email")}
                                    size="medium"
                                    style={{}}
                                    autoComplete="off"
                                    suggestions={users}
                                    delay={0}
                                    limitSuggestions={users.length}
                                />
                                {existingSafeMembers.length > 0 && <div className="mb-1">
                                    <label className="safe-name">{t("mypam.added_members")}</label>
                                    <div className="accountsAlign">
                                        {existingSafeMembers?.map((acc, index) => (
                                            <span key={acc?.id} className="endPointInfo mr-1">{acc?.id}{" "}
                                                {!safeOwnersOnUpdate?.some(owner => owner.id === acc?.id) &&
                                                    <Icon
                                                        alt="alt value"
                                                        className="icon $color-icon small material-icons-outlined ml-1"
                                                        icon="close"
                                                        size="small"
                                                        onClick={() => removeFromSafeMembers(acc?.id, true)}
                                                        style={{ color: 'white', cursor: "pointer" }}
                                                    />
                                                }
                                                {" "}</span>
                                        ))}
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </>
            }

        </div>
        <div className="create-update-safe-footer px-3">
            <button className="extension-cancel-button mr-2" onClick={() => navigate(-1)} >
                {t('nonArExtension.cancel')}
            </button>

            <Button
                size="medium"
                text={t("active_directory.submit")}
                variant="primary"
                disabled={requestType?.[0]?.value === "Create_Safe" ? (!selectedApp || !environment?.length || !shortName || !description || !safeOwners?.length || !safeMembers?.length) : !updateSafeName?.length || areArraysSame(existingSafeMembers, existingSafeMembersResp)}
                onClick={() => {
                    if (requestType?.[0]?.value === "Create_Safe") {
                        handleCreateSafe();
                    } else {
                        handleUpdateSafe();
                    }
                }}
            />
            <ToastContainer
                position="bottom-center"
            />
            {showModal && renderConfirmModal()}
        </div>
    </div>
}

export default PamSafeCreateUpdate;